<div class="modal-content modern-modal border-0 shadow-lg">
  <div class="modal-header border-0 bg-transparent pt-4 px-4">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="header-content d-flex align-items-center">
        <h1 class="modern-header mb-0">
          <i class="fa-solid fa-calendar-{{ isEditMode ? 'check' : 'plus' }} me-2 text-primary"></i>
          {{ isEditMode ? 'Edit Event' : 'Schedule Event' }}
        </h1>
        @if (selectedDate) {
          <div class="date-badge ms-4 ps-2">
           {{ selectedDate }}
          </div>
        }
      </div>
      <button type="button" class="close-btn" (click)="close()" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>

  <div class="modal-body px-4 py-3">
    <form [formGroup]="event_form">
      <div class="row g-4">
        <!-- Event Title -->
        <div class="col-12">
          <div class="form-group">
            <label class="modern-label mb-2">Event Title</label>
            <ng-select
              [items]="eventTitles"
              [addTag]="true"
              formControlName="title"
              placeholder="Select or type event name..."
              class="modern-select"
            >
            </ng-select>
          </div>
        </div>

        <!-- Scheduling Row -->
        <div class="col-md-4">
          <div class="form-group">
            <label class="modern-label mb-2">Event Date</label>
            <div class="input-group">
              <span class="input-group-text bg-transparent border-end-0 text-muted">
                <i class="fa-regular fa-calendar"></i>
              </span>
              <input
                type="text"
                class="form-control modern-input border-start-0 ps-2"
                formControlName="event_date"
                bsDatepicker
                [minDate]="minDate"
                [bsConfig]="{ containerClass: 'theme-dark-blue', dateInputFormat: 'MM/DD/YYYY' }"
              />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="modern-label mb-2">Time</label>
            <div class="dark-timepicker compact-timepicker no-border">
              <timepicker 
                formControlName="begin_time" 
                [showSpinners]="false"
                [mousewheel]="true"
                [showMeridian]="true"
              ></timepicker>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="modern-label mb-2">Duration</label>
            <ng-select
              [items]="durations"
              bindLabel="label"
              bindValue="value"
              formControlName="duration"
              [clearable]="false"
              [searchable]="false"
              class="modern-select"
            >
            </ng-select>
          </div>
        </div>

        <!-- Customer Selection -->
        <!-- Customer and Reminder -->
        <div class="col-12">
          <div class="row align-items-end">
            <!-- Customer -->
            <div class="col-md-7">
              <div class="form-group mb-0">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="modern-label">Customer</label>
                  <button
                    type="button"
                    class="btn btn-link btn-sm text-primary p-0 text-decoration-none"
                    (click)="addNewCustomer()"
                  >
                    <i class="fa-solid fa-plus me-1"></i>New Customer
                  </button>
                </div>
                <ng-select
                  [items]="customers"
                  bindLabel="contact.display_name"
                  bindValue="id"
                  formControlName="customer_id"
                  placeholder="Search or select customer..."
                  class="modern-select"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="d-flex flex-column">
                      <span class="fw-bold">{{ item.contact.display_name }}</span>
                      <small class="text-muted">{{ item.contact.email }} | {{ item.contact.phone_number }}</small>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <!-- Send Reminder Checkbox -->
            <div class="col-md-5">
              <div class="d-flex align-items-center px-0 rounded-3" style="height: 42px;">
                <div class="form-check form-switch modern-switch d-flex align-items-center mb-0 w-100">
                  <input
                    class="form-check-input clickable m-0"
                    type="checkbox"
                    id="sendReminder"
                    formControlName="send_reminder"
                  />
                  <label 
                    class="form-check-label modern-label ms-2 mb-0 clickable text-truncate" 
                    for="sendReminder" 
                    [title]="hasCustomerPhone ? 'Send a text reminder to the customer' : 'Customer must have a phone number to send a text'"
                    [class.text-muted]="!hasCustomerPhone"
                  >
                    <i class="fa-solid fa-comment-sms me-1" [class.text-info]="hasCustomerPhone" [class.text-muted]="!hasCustomerPhone"></i>
                    Send Text
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="col-12">
          <div class="form-group mt-3">
            <label class="modern-label mb-2">Notes / Description</label>
            <textarea
              class="form-control modern-input w-100"
              formControlName="description"
              rows="5"
              placeholder="Add any additional details here..."
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer border-0 px-4 pb-4 pt-2 d-flex justify-content-between align-items-center">
    <div>
      @if (isEditMode) {
        <button type="button" class="btn modern-btn danger-btn px-4" (click)="deleteEvent()">
          <i class="fa-solid fa-trash-can me-2"></i> Delete
        </button>
      }
    </div>
    <div class="d-flex gap-3">
      <button type="button" class="btn modern-btn secondary-btn px-4" (click)="close()">
        Cancel
      </button>
      <button
        type="button"
        class="btn modern-btn primary-btn px-5"
        (click)="saveEvent()"
        [disabled]="event_form.invalid"
      >
        {{ isEditMode ? 'Save Changes' : 'Save Event' }}
      </button>
    </div>
  </div>
</div>

